import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

/* Shared locale engine — use relative path for api-docs compatibility */
import { resolveLocale } from '../../../shared/locale/detectLocale';
import { persistLocale } from '../../../shared/locale/persistLocale';
import { applyDocumentLocale } from '../../../shared/locale/applyDocumentLocale';
import { SUPPORTED_LOCALES, LOCALE_STORAGE_KEY, LOCALE_COOKIE_KEY, LOCALE_QUERY_PARAM } from '../../../shared/locale/constants';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: resolveLocale(),
    fallbackLng: 'en',
    supportedLngs: [...SUPPORTED_LOCALES],
    load: 'languageOnly',
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      lookupQuerystring: LOCALE_QUERY_PARAM,
      lookupCookie: LOCALE_COOKIE_KEY,
      lookupLocalStorage: LOCALE_STORAGE_KEY,
      caches: ['localStorage', 'cookie'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

i18n.on('languageChanged', (lng: string) => {
  applyDocumentLocale(lng);
  persistLocale(lng);
});

// Initial document locale sync
applyDocumentLocale(i18n.language);

export default i18n;
